import useRoles from 'hooks/business/useRoles';
import dayjs from 'lib/dayjs';
import { isAeProduct, isMasterOnline, isSiteGiant } from 'productLine';
import { atom, useAtomValue, useSetAtom } from 'jotai';
import { hidePayment } from 'services/chattt';

export const incentiveState = atom<Incentive.Info | undefined>(undefined);

export const useIncentiveValue = () => useAtomValue(incentiveState);

export const useSetIncentive = () => useSetAtom(incentiveState);

export const incentiveTypes: Incentive.ActivityType[] = [
  'NEW_SELLER_ACTIVITY',
  'E_COMMERCE_EVENT_FESTIVAL',
];

export const useIncentiveType = () => {
  const { activityExpireDay = -1, activityType } = useIncentiveValue() || {};
  return activityExpireDay !== -1 && incentiveTypes.includes(activityType) && activityType;
};

export const shouldShowIncentive = ({
  incentiveType,
  activityType,
  isSuperviser,
}: {
  incentiveType: false | Incentive.ActivityType;
  activityType?: Incentive.ActivityType;
  isSuperviser: boolean;
}) => {
  return (
    (!activityType || activityType === incentiveType) &&
    !isAeProduct &&
    !hidePayment &&
    !isSiteGiant &&
    !isMasterOnline &&
    isSuperviser &&
    incentiveType
  );
};

export const useShowIncentive = (activityType?: Incentive.ActivityType) => {
  const { isSuperviser } = useRoles();

  const incentiveType = useIncentiveType();

  return shouldShowIncentive({ isSuperviser, incentiveType, activityType });
};

export const getUsedDay = (activityStartTimestamp?: number) =>
  activityStartTimestamp === undefined
    ? '-'
    : Math.ceil(dayjs().diff(dayjs(activityStartTimestamp), 'days', true));

export const getExpireDate = (activityExpireDay?: number) =>
  activityExpireDay === undefined
    ? '-'
    : dayjs().add(activityExpireDay, 'days').format('YYYY-MM-DD');
